export default __webpack_public_path__ + "static/media/LincolnFavicon.3efdbc9a.ico";